import { render, staticRenderFns } from "./CreateSector.vue?vue&type=template&id=4f66d475"
import script from "./CreateSector.vue?vue&type=script&lang=js"
export * from "./CreateSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports